module.exports = __webpack_public_path__ + "static/img/chatateless.7eb43a2.jpg";